import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './sideEffectBundle.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class SideEffectBundleDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      this.props.sideEffectBundle.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'sideeffect_' + this.props.sideEffectBundle.termDuration}>
        <div className="col-md-4 primary-data">
          {
            this.props.sideEffectBundle.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.sideEffectBundle.termDuration}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<span></span>}
                value={this.props.sideEffectBundle.sideEffectList} language={this.props.language}
                isActive={this.configurationActive('SideEffectList')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.sideEffectBundle.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="sideeffect_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.sideEffectBundle.nullMessage}
        </div>
      </div>
    );
  }
}

SideEffectBundleDetail.propTypes = {
  sideEffectBundle: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
